
    import Vue from "vue";
    import colors from "vuetify/lib/util/colors"
    import { mapGetters } from 'vuex';
    import { SettingService } from '../../services/SettingService';
    import { ApplicationSetting } from "@/models/Enums";
    import ApplicationSettingDto from '../../models/api/ApplicationSetting';
    import { SnackbarService } from '../../services/SnackbarService';

    export default Vue.extend({
        name: "ThemeChanger",
        data() {
            return {
                themes: [
                    {
                        name: "Default",
                        light: {
                            primary: colors.blue.darken4,
                            accent: colors.blue,
                            secondary: colors.lime,
                            success: colors.lightGreen,
                            info: colors.blueGrey,
                            warning: colors.amber,
                            error: colors.deepOrange.darken3
                        }
                    },
                    {
                        name: "Test-tema",
                        light: {
                            primary: colors.green.darken4,
                            accent: colors.green,
                            secondary: colors.yellow.darken4,
                            success: colors.lightGreen,
                            info: colors.blueGrey,
                            warning: colors.amber,
                            error: colors.deepOrange.darken3
                        }
                    },
                ],
                items: [] as ApplicationSettingDto[],
                ApplicationSetting: ApplicationSetting,
            }
        },
        created() {
            this.getSettings();
        },
        methods: {
            getApplicationSettingIndex(app: ApplicationSetting) {
                console.log(this.items);
                console.log(app)
                const index = this.items.findIndex((val: any) => val.keyName == app);
                console.log("Index: " + index);
                return index;
            },
            async getSettings() {
                this.$store.commit('addOverlay');

                SettingService.GetSettingsByKeyNames("ThemeAccent,ThemeError,ThemeInfo,ThemePrimary,ThemeSecondary,ThemeSuccess,ThemeWarning").then(response => {
                    this.items = response.data;
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.$store.commit('removeOverlay');
                });
            },
            getApplicationSettingColor(app: ApplicationSetting): string {
                let settingString = this.items[this.getApplicationSettingIndex(app)].value.toString();
                let colorText = "";
                try {
                    const colorObject = JSON.parse(settingString);
                    colorText = colorObject['base'];
                } catch (e) {
                    colorText = settingString;
                }

                return colorText;
            },
            setSetting(app: ApplicationSetting, value: any) {
                this.items[this.getApplicationSettingIndex(app)].value = typeof value === 'string' || value instanceof String ? value.toString() : JSON.stringify(value);
            },
            setTheme(theme: any) {
                const name = theme.name;
                const light = theme.light;

                this.setSetting(ApplicationSetting.ThemeAccent, light['accent']);
                this.setSetting(ApplicationSetting.ThemeError, light['error']);
                this.setSetting(ApplicationSetting.ThemeInfo, light['info']);
                this.setSetting(ApplicationSetting.ThemePrimary, light['primary']);
                this.setSetting(ApplicationSetting.ThemeSecondary, light['secondary']);
                this.setSetting(ApplicationSetting.ThemeSuccess, light['success']);
                this.setSetting(ApplicationSetting.ThemeWarning, light['warning']);

                this.$store.commit('addOverlay');

                SettingService.SaveSetting(this.items).then(() => {

                    Object.keys(light).forEach(i => {
                        this.$vuetify.theme.themes.light[i] = light[i];
                    });

                    this.getSettings();

                    SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.saved'));

                }).catch((error) => {
                    if (error.response.data.errors) {
                        SnackbarService.addErrorMessage(error.response?.data || error.response?.statusText);
                    } else {
                        SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                    }
                }).finally(() => {
                    this.$store.commit('removeOverlay');
                });

                
            }
        },
        computed: {
            ...mapGetters([
                "isSystemAdmin",
                "isMunicipalityAdmin",]),
        }
    });
